<template>
  <div class="instruction-task">
    <div class="name">
      <div class="label">ชื่องาน</div>
      <el-input
        :value="value.name"
        :disabled="disabled"
        @input="handleFieldChange('name', $event)"
      ></el-input>
    </div>
    <div class="prog">
      <div class="label">ความคืบหน้า (%)</div>
      <el-input
        :value="value.progress"
        :disabled="disabled"
        @input="handleFieldChange('progress', $event)"
      ></el-input>
    </div>
    <div class="start-at">
      <div class="label">เริ่มต้นเมื่อ</div>
      <date-picker
        :value="value.startAt"
        :disabled="disabled"
        @input="handleFieldChange('startAt', $event)"
      ></date-picker>
    </div>
    <sc-button
      v-if="!disabled"
      class="btn-remove"
      variant="danger"
      @click="handleClick"
      >ลบ</sc-button
    >
  </div>
</template>

<script>
import { Input } from "element-ui"
import ScButton from "@/lib/components/ScButton"
import DatePicker from "@/lib/components/DatePicker"

export default {
  components: {
    ScButton,
    "el-input": Input,
    DatePicker,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    disabled: {
      type: null,
      default: undefined,
    },
  },
  methods: {
    handleFieldChange(key, fieldValue) {
      this.$emit("input", { ...this.value, [key]: fieldValue })
    },
    handleClick() {
      this.$emit("remove")
    },
  },
}
</script>

<style lang="scss" scoped>
.instruction-task {
  display: grid;
  grid-template-columns: 1fr 100px 220px 60px;
  grid-gap: 30px;
}

.label {
  font-size: 14px;
  color: #666;
  margin-bottom: 4px;
}

.btn-remove {
  margin-top: 25px;
  min-width: 0 !important;

  text-align: center;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

@media (max-width: 600px) {
  .instruction-task {
    grid-gap: 5px 30px;
    grid-template-columns: 1fr 1fr;
  }
}
</style>
